import DataTableEditableSelectCell from './DataTableEditableSelectCell';

export default DataTableEditableSelectCell;
